var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconpubli(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74375 11.5H14.3688L11.7063 7.99375L9.34375 11.125L7.61875 9.00625L5.74375 11.5ZM2.5 17.5V3.625C2.5 3.325 2.6125 3.0625 2.8375 2.8375C3.0625 2.6125 3.325 2.5 3.625 2.5H16.375C16.675 2.5 16.9375 2.6125 17.1625 2.8375C17.3875 3.0625 17.5 3.325 17.5 3.625V13.375C17.5 13.675 17.3875 13.9375 17.1625 14.1625C16.9375 14.3875 16.675 14.5 16.375 14.5H5.5L2.5 17.5Z",
    fill: "#BED000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconpubli);
export default __webpack_public_path__ + "static/media/iconpubli.60dbeed7731fae048460c842f42acc56.svg";
export { ForwardRef as ReactComponent };